<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-spinner *ngIf="isLoading"></app-spinner>
<notifier-container></notifier-container>